import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Landmark, ArrowRight } from "lucide-react";

export const ContactSection = ({ profile }) => {
  const q = encodeURIComponent("Masjid Al-Iman Banjarwaru Kawali Ciamis");
  return (
    <footer id="kontak" className="emerald-bg pattern-overlay text-emerald-50 scroll-mt-24" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid lg:grid-cols-2 gap-12">
        <div className="space-y-7">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-2xl bg-[#d4af37] text-emerald-950 flex items-center justify-center"><Landmark size={20} /></div>
            <div>
              <p className="text-xs uppercase tracking-widest text-[#80b996] font-semibold">Hubungi Kami</p>
              <h2 className="text-2xl sm:text-3xl font-bold">{profile?.name || "Masjid Al-Iman"}</h2>
            </div>
          </div>
          <p className="text-sm text-emerald-100/80 leading-relaxed -mt-3">Kunjungi kami di Dusun Banjarwaru, Desa Kawali. Pengurus siap membantu untuk informasi kegiatan, donasi, maupun layanan kemasjidan.</p>
          <Link to="/kontak" className="inline-flex items-center gap-2 rounded-full border border-[#d4af37]/60 text-[#d4af37] text-sm font-semibold px-5 py-2.5 hover:bg-[#d4af37] hover:text-emerald-950 transition-colors" data-testid="contact-see-all">
            Lihat Selengkapnya & Kirim Pesan <ArrowRight size={15} />
          </Link>
          <div className="space-y-4 text-sm text-emerald-100/90">
            <p className="flex gap-3" data-testid="contact-address">
              <a href="https://maps.app.goo.gl/w2YZf7P37et7EF5v5" target="_blank" rel="noopener noreferrer" className="shrink-0 text-[#d4af37] hover:text-[#e2c15a]" aria-label="Buka di Google Maps" data-testid="contact-maps-link">
                <MapPin size={18} />
              </a>
              <span>{profile?.address}</span>
            </p>
            {profile?.phone && <p className="flex gap-3" data-testid="contact-phone"><Phone size={18} className="shrink-0 text-[#d4af37]" /> {profile.phone}</p>}
            {profile?.email && <p className="flex gap-3" data-testid="contact-email"><Mail size={18} className="shrink-0 text-[#d4af37]" /> {profile.email}</p>}
          </div>
          {(profile?.vision || profile?.mission) && (
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="rounded-2xl bg-white/5 border border-white/10 p-5">
                <p className="text-xs uppercase tracking-widest text-[#d4af37] font-semibold">Visi</p>
                <p className="mt-2 text-sm text-emerald-100/90 leading-relaxed">{profile.vision}</p>
              </div>
              <div className="rounded-2xl bg-white/5 border border-white/10 p-5">
                <p className="text-xs uppercase tracking-widest text-[#d4af37] font-semibold">Misi</p>
                <p className="mt-2 text-sm text-emerald-100/90 leading-relaxed">{profile.mission}</p>
              </div>
            </div>
          )}
        </div>
        <div className="rounded-3xl overflow-hidden border border-white/15 min-h-[320px] bg-black/20">
          <iframe
            title="Peta Masjid Al-Iman"
            src={`https://maps.google.com/maps?q=${q}&z=15&output=embed`}
            className="w-full h-full min-h-[320px]"
            loading="lazy"
            data-testid="contact-map"
          />
        </div>
      </div>
      <div className="border-t border-white/10">
        <p className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-emerald-300/70 flex flex-wrap justify-between gap-2">
          <span data-testid="footer-copyright">© 2026 Al-Iman Digital - Desain by: Aher</span>
          <span className="flex items-center gap-4">
            <span className="font-arabic text-sm">وَأَنَّ الْمَسَاجِدَ لِلَّهِ</span>
            <Link to="/admin" className="text-[10px] text-emerald-300/40 hover:text-emerald-200 transition-colors" data-testid="footer-admin-link">Admin</Link>
          </span>
        </p>
      </div>
    </footer>
  );
};
